import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Calendar } from 'antd';
import './styles.css';

const SelectDateWithCalendar = ({ dateSelected, onSelected, disabledBeforeTodayDate, datesWithReservations }) => {
    return (
        <div className="SelectDateCont">
            {
                disabledBeforeTodayDate ?
                    <div style={{ width: '100%', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                        <Calendar 
                        className="CalendarCont"
                        dateFullCellRender={current => {
                            var style = {};
                            const currentDate = moment(current).format("DD/MM/YYYY");
                            if(currentDate === dateSelected) {
                                style.color = "#94509b"
                                style.fontWeight = "bold"
                            }
                            if (datesWithReservations && datesWithReservations.indexOf(currentDate) !== -1) {
                                style.border = '1px solid #7078b8';
                                style.borderRadius = '30%';
                            } else {
                                /*let customDate = moment(new Date()).format("YYYY-MM-DD");
                                if(current && current < moment(customDate, "YYYY-MM-DD")) {
                                    style.cursor = 'not-allowed'
                                    style.color = '#D3D3D3'
                                }*/
                            }
                            return (
                                <div className="ant-calendar-date" style={style}>
                                    {current.date()}
                                </div>
                            );
                        }}
                        format={'DD/MM/YYYY'} 
                        defaultValue={moment(dateSelected, 'DD/MM/YYYY')}
                        onSelect={(date) => onSelected(date)}
                        fullscreen={false}
                        disabledDate={(current) => {
                            let customDate = moment(new Date()).subtract(3, 'd').format("YYYY-MM-DD");
                            return current && current < moment(customDate, "YYYY-MM-DD");
                        }}
                         />
                    </div>
                    :
                    <div style={{ width: 300, border: '1px solid #d9d9d9', borderRadius: 4 }}>
                        <Calendar 
                        format={'DD/MM/YYYY'} 
                        defaultValue={moment(dateSelected, 'DD/MM/YYYY')}
                        onSelect={(date) => onSelected(date)}
                        fullscreen={false} />
                    </div>
            }
            
        </div>
    );
};

SelectDateWithCalendar.propTypes = {
    dateSelected: PropTypes.string,
    onSelected: PropTypes.func.isRequired,
    disabledBeforeTodayDate: PropTypes.bool.isRequired,
}

export default SelectDateWithCalendar;